import React, { useState, useEffect, useRef } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { adminActions } from '../../_actions';
import ReactPaginate from 'react-paginate';
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { AiOutlineStop } from "react-icons/ai";
import { LuArrowUpDown } from 'react-icons/lu';

const useClickOutside = (handler) => {
  const menuRef = useRef();
  const buttonRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handler]);

  return { menuRef, buttonRef };
};

const AdminTable = ({
  theadData,
  tbodyData,
  handleEdit,
  handleView,
  handleUserDelete,
  handlePageClick,
  size
}) => {
  const dispatch = useDispatch();
  const [openMenuId, setOpenMenuId] = useState(null);

  const { menuRef, buttonRef } = useClickOutside(() => {
    setOpenMenuId(null);
  });

  const orderOptions = [
    { label: "Id", value: "id" },
    { label: "Name", value: "name" },
    { label: "User Name", value: "user_name" },
    { label: "Admin Type", value: "admin_type" },
    { label: "Email", value: "email" },
    { label: "Phone", value: "phone" },
    { label: "Access", value: "access" },
    { label: "Created At", value: "created_at" },
    { label: "Last Updated", value: "updated_at" },
  ];

  const orderBy = [
    { label: "ASC", value: "Asc" },
    { label: "DESC", value: "Desc" }
  ];

  const [sortValue, setSortValue] = useState({ sortBy: "", sortOrder: "" });
  const [sortOrder, setSortOrder] = useState("DESC");

  const handleOrderChange = (e) => {
    const { name, value } = e.target;
    setSortValue({ ...sortValue, [name]: value });
  };

  const handleSortOrder = () => {
    dispatch(adminActions.adminList({ sortBy: sortValue.sortBy, sortOrder: sortValue.sortOrder }));
  };

  const sortFunction = (index) => {
    const sortKey = ['id', 'user_name', 'email', 'phone', 'admin_type'];
    if (!sortKey[index]) return;
    dispatch(adminActions.adminList({ sortBy: sortKey[index], sortOrder: sortOrder }));
    setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  return (
    <div>
      <div className="overflow-x-auto ">
        <div className='flex justify-between items-center flex-wrap border-b pb-3'>
          <h1 className="text-lg font-bold xl:pb-0 pb-2">Admin</h1>
          <div className='flex justify-between items-center space-x-3'>
            <div className='md:space-x-2 space-x-0'>
              <select className='px-2 py-1.5 bg-white border rounded-md outline-none' name="sortBy" value={sortValue.sortBy} onChange={handleOrderChange}>
                <option value="" selected disabled="disabled">Order By</option>
                {orderOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>))}</select>
            </div>
            <div>
              <select className='px-2 py-1.5 bg-white border rounded-md outline-none' name="sortOrder" value={sortValue.sortOrder} onChange={handleOrderChange}>
                <option value="" selected disabled="disabled">Sort By</option>
                {orderBy.map(opt =>
                  (<option key={opt.value} value={opt.value}>{opt.label}</option>))}</select>
            </div>
            <div>
              <button className='bgbtn rounded-md px-4 py-2' onClick={handleSortOrder}>Go</button>
            </div>
          </div>
        </div>
        <table className="min-w-full text-sm text-left text-gray-500  border ">
          <thead className="text-black capitalize border-b bg-gray-100">
            <tr>
              {theadData.map((header, index) => (
                <th
                  key={index}
                  className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200"
                  onClick={() => sortFunction(index)}
                >
                  <div className='flex items-center space-x-1'>
                    <span> {header}</span>
                    {!["Actions"].includes(header) && <LuArrowUpDown className='w-3 h-4 text-gray-500' />}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tbodyData?.total !== 0 && tbodyData?.list.map((row, index) => (
              <tr key={index} className="bg-white whitespace-nowrap hover:bg-gray-50 font-normal text-[#212121] border-b capitalize">
                <td className="px-4 py-2">{row.id}</td>
                <td className="px-4 py-2">{row?.user_name}</td>
                <td className="px-4 py-2">{row?.email}</td>
                <td className="px-4 py-2">{row?.phone}</td>
                <td className="px-4 py-2">{row?.admin_type}</td>
                <td className="px-4 py-2">
                  <div className='relative '>
                    <button
                      ref={openMenuId === row?.id ? buttonRef : null}
                      className="w-8 h-8 rounded-md flex justify-center items-center text-black hover:bg-gray-100"
                      onClick={() => toggleMenu(row?.id)}
                    >
                      <BsThreeDotsVertical className="text-xl" />
                    </button>
                    {openMenuId === row?.id && (
                      <div
                        ref={menuRef}
                        className="absolute bottom-0 right-28 bg-white z-50"
                      >
                        <ul className="w-36 rounded-md border shadow divide-y divide-gray-100">
                          <li>
                            <button
                              className="flex items-center space-x-3 w-full px-4 py-2 text-left hover:bg-gray-50"
                              onClick={() => {
                                handleEdit(row);
                                setOpenMenuId(null);
                              }}
                            >
                              <span><MdEdit className='w-4 h-4' /></span>
                              <span>Edit</span>
                            </button>
                          </li>
                          <li>
                            <button
                              className="flex items-center space-x-3 w-full px-4 py-2 text-left hover:bg-gray-50"
                              onClick={() => {
                                handleUserDelete({ id: row.id });
                                setOpenMenuId(null);
                              }}
                            >
                              <span><RiDeleteBinLine className='w-4 h-4' /></span>
                              <span>Delete</span>
                            </button>
                          </li>
                          <li>
                            <button
                              className="flex items-center space-x-3 w-full px-4 py-2 text-left hover:bg-gray-50"
                              onClick={() => {
                                handleView(row);
                                setOpenMenuId(null);
                              }}
                            >
                              <span><MdOutlineRemoveRedEye className='w-4 h-4' /></span>
                              <span>View</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(!tbodyData || tbodyData.total === 0) && (
          <div className="flex items-center justify-center mt-5">
            <h2>Admin not exists.</h2>
          </div>
        )}
      </div>
      {tbodyData?.total > size && (
        <div className="py-2 pt-6">
          <ReactPaginate
            previousLabel="Prev"
            nextLabel="Next"
            breakLabel="..."
            breakClassName="break-me"
            pageCount={Math.ceil(tbodyData.total / size)}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            pageClassName="page-cls"
            activeClassName="active"
          />
        </div>
      )}
    </div>
  );
};

export default AdminTable;